import React from "react";
import { Segment, Button, Icon } from "semantic-ui-react";

export default class UploadButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hovered: false,
            error: false,
        };
    }

    handleChange = (e) => {
        // get the files
        let files = e.target.files;
        let target = e.target;
        // Process each file
        var allFiles = [];
        for (var i = 0; i < files.length; i++) {
            let file = files[i];

            // Make new FileReader
            let reader = new FileReader();

            // Convert the file to base64 text
            reader.readAsDataURL(file);

            // on reader load somthing...
            reader.onload = () => {
                let _this = this;
                if (
                    file.size <
                    this.props.article.owner.license.maxSpace * 2.5
                ) {
                    // Make a fileInfo Object
                    let fileInfo = {
                        name: file.name,
                        type: file.type,
                        size: Math.round(file.size / 1000) + " kB",
                        base64: reader.result,
                        file: file,
                    };

                    // Push it to the state
                    allFiles.push(fileInfo);

                    // If all files have been processed
                    if (allFiles.length === files.length) {
                        // Apply Callback function
                        target.value = null;
                        if (this.props.multiple) this.props.onDone(allFiles);
                        else this.props.onDone(allFiles[0]);
                    }
                } else {
                    this.setState({ error: true }, () => {
                        setTimeout(() => {
                            _this.setState({ error: false });
                        }, 1500);
                    });
                }
            }; // reader.onload
        } // for
    };

    setHover = () => this.setState({ hovered: true });
    removeHover = () => this.setState({ hovered: false });

    render() {
        let hiddenInput = {
            display: "none",
        };
        let uploadImgBtn = {
            width: "100%",
            padding: "30px",
            position: "relative",
            cursor: "pointer",
            overflow: "hidden",
            marginBottom: "5px",
            borderRadius: "5px",
        };
        let uploadImgBtnOverlay = {
            position: "absolute",
            width: "100%",
            height: "100%",
            left: "0",
            top: "0",
        };
        let uploadImgLabel = {
            position: "absolute",
            width: "100%",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            textAlign: "center",
            fontSize: "1.5em",
            cursor: "pointer",
            padding: "10px",
        };
        let componentStyles = {
            default: {
                ...uploadImgBtn,
                background: this.state.error
                    ? "#e57373"
                    : this.state.hovered
                    ? this.props.colors.primaryVariation
                    : this.props.secondary
                    ? this.props.colors.secondary
                    : this.props.colors.primary,
                color: this.state.error
                    ? "white"
                    : this.props.secondary
                    ? this.props.colors.secondaryText
                    : this.props.colors.primaryText,
            },
            grid: {
                ...uploadImgBtn,
                background: this.state.error
                    ? "#e57373"
                    : this.state.hovered
                    ? this.props.colors.primaryVariation
                    : this.props.secondary
                    ? this.props.colors.secondary
                    : this.props.colors.primary,
                color: this.state.error
                    ? "white"
                    : this.props.secondary
                    ? this.props.colors.secondaryText
                    : this.props.colors.primaryText,
            },
        };
        if (this.props.uploaded)
            return (
                <Segment
                    color="yellow"
                    style={{
                        fontSize: "1.25em",
                        marginBottom: "15px",
                    }}
                >
                    <Icon name="check" />
                    File Uploaded
                    <br />
                    <br />
                    <Button
                        secondary
                        content="Upload Again"
                        onClick={this.props.reset}
                    />
                </Segment>
            );
        else
            return (
                <div>
                    <div
                        style={componentStyles[this.props.layout]}
                        onMouseEnter={this.setHover}
                        onMouseLeave={this.removeHover}
                    >
                        <input
                            type="file"
                            name={this.props.name}
                            id={"uploadFile"}
                            style={hiddenInput}
                            onChange={this.handleChange}
                            multiple={this.props.multiple}
                            accept={this.props.accept}
                        />
                        <label htmlFor="uploadFile">
                            <div style={uploadImgBtnOverlay} />
                            {this.state.error ? (
                                <div style={uploadImgLabel}>
                                    <Icon name={"bell"} />
                                    File size too large!
                                </div>
                            ) : (
                                <div style={uploadImgLabel}>
                                    <Icon name={"upload"} />
                                    {this.props.data.button}
                                </div>
                            )}
                        </label>
                    </div>
                    <p>
                        Upload size must be less than{" "}
                        {this.props.article.owner.license.maxSpace * 0.0025}kB
                    </p>
                </div>
            );
    }
}
